import React from "react";
import { Box, FormControl, InputLabel, MenuItem, Select, Stack } from "@mui/material";
import BmcBusinessTask from "./BmcBusinessTask";
import BmcAnexoBusinessTask from "./BmcAnexoBusinessTask";
import BmcStatusBusinessTask from "./BmcStatusBusinessTask";

const RootBusinessTask = React.forwardRef((props, ref) => {
    const { item, processo, onClose } = props;

    const childRef = React.useRef();

    const [tipo, setTipo] = React.useState('camel');
    React.useImperativeHandle(ref, ()=> ({
        childMethod() {
            salva();
          }
    }))

    React.useEffect(()=>{
        const tk = processo.lstTask.find( t => t.idTask === item.id);
        console.log(1);
        if( tk ){
            console.log( tk );
            setTipo( tk.tipo);
            // setCode( tk.codigo );
            // setEmail( tk.dado.email);
            // setAssunto( tk.dado.assunto);
            // setCorpo( tk.dado.corpo);
        }
    },[]);

    function salva(){
        console.log('>>>salva from parent<<<');
        if(childRef && childRef.current) childRef.current.childMethod();
    }

    function montaFilho(){

        switch( tipo){
            case 'camel': return (<h3>a ser implementado</h3>); break
            case 'BMC': return (<BmcBusinessTask ref={childRef} item={item} processo={processo} />); break
            case 'BMC-ANEXO': return (<BmcAnexoBusinessTask ref={childRef} item={item} processo={processo} />); break
            case 'BMC-STATUS': return (<BmcStatusBusinessTask ref={childRef} item={item} processo={processo} />); break
        }
        // if( tipo === 'camel'){
        //     return (
        //         <h3>a ser implementado</h3>
        //     )
        // }
        // if( tipo === 'camel'){
        //     return (
        //         <h3>a ser implementado</h3>
        //     )
        // }
        return (
            <h2>Não implementado</h2>
        )
    }
    return (
        <Stack spacing={2} style={{ width:'100%'}}>
            <Box sx={{ minWidth: 220 }}>
            <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Escola a classe de negocio</InputLabel>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={tipo}
                    label="Escola a classe de negocio"
                    onChange={(e) => setTipo( e.target.value ) }
                >
                    <MenuItem value={'camel'}>Classe Camel</MenuItem>
                    <MenuItem value={'BMC'}>Classe BMC</MenuItem>
                    <MenuItem value={'BMC-ANEXO'}>Classe BMC Anexo</MenuItem>
                    <MenuItem value={'BMC-STATUS'}>Classe BMC Status</MenuItem>
                </Select>
            </FormControl>
            </Box>
            { montaFilho() }
        </Stack>
    )
})

export default RootBusinessTask;